import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { EnvBanner } from "./EnvBanner";
import { CookieConsent } from "./CookieConsent";
import { ImpersonationBanner } from "./ImpersonationBanner";

export const Layout = () => (
  <div className="bg-background flex min-h-screen flex-col">
    <EnvBanner />
    <ImpersonationBanner />
    {/* a11y: skip link — hidden off-screen via -translate-y-full, slides into view on keyboard focus */}
    <a
      href="#main-content"
      className="fixed top-0 left-1/2 -translate-x-1/2 -translate-y-full focus:translate-y-0 z-[200] px-6 py-3 bg-primary text-primary-foreground text-sm font-semibold rounded-b-xl shadow-lg transition-transform duration-150 focus:outline-none"
    >
      Skip to main content
    </a>
    <Header />
    {/* main shrink-wraps content so the footer hugs short pages instead of leaving a blank gap */}
    <main id="main-content" className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <CookieConsent />
  </div>
);
